import { observer } from 'mobx-react';
import React from 'react';
import { makeAutoObservable } from 'mobx';
import { Spinner, SpinnerSize, Stack } from '@fluentui/react';
import { EntityType, IEntityTypeUserInfo, IGenericEntity } from '../../API';
import { IUserConfigPackage } from '../../API';

import OutlookLocationContentsViewerState, {
	IContextCommands,
	IOutlookAppCommands,
} from '../../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook';
import LegalEntityRootFolder from '../../outlook/LegalEntityRootFolder';

interface IEntityNavigatorProps {
	state: EntityNavigatorState;
}

class EntityNavigator extends React.Component<IEntityNavigatorProps, {}> {
	componentDidMount(): void {
		if (!this.props.state.loading && !this.props.state.documentViewers) {
			this.props.state.load();
		}
	}

	render() {
		//let label = this.props.state.entityInfo?.pluralName;

		return (
			<Stack>
				{this.props.state.loading && <Spinner size={SpinnerSize.large} />}

				{this.props.state.documentViewers &&
					this.props.state.documentViewers.map((d) => (
						<LegalEntityRootFolder state={d} />
					))}
			</Stack>
		);
	}
}

export class EntityNavigatorState {
	public entityType: string | EntityType;

	public loading: boolean = false;

	public documentViewers?: OutlookLocationContentsViewerState[];

	public entityInfo?: IEntityTypeUserInfo;
	private entities: IGenericEntity[];
	private userConfig: IUserConfigPackage;
	private commands: IOutlookAppCommands;
	ctxCommands: IContextCommands;


	constructor(
		userConfig: IUserConfigPackage,
		entityType: string | EntityType,
		entities: IGenericEntity[],
		commands: IOutlookAppCommands,
		ctxCommands: IContextCommands,
	) {
		makeAutoObservable(this);
		this.userConfig = userConfig;
		this.entityType = entityType;
		this.entities = entities;
		this.commands = commands;
		this.ctxCommands = ctxCommands;
		this.entityInfo = userConfig.entityTypes.getConfig(entityType);
	}

	public setViewers(docViewers: OutlookLocationContentsViewerState[]) {
		this.documentViewers = docViewers;
	}

	public remove(viewer: OutlookLocationContentsViewerState): void {
		if (this.documentViewers) {
			this.documentViewers = this.documentViewers.filter((d) => d !== viewer);
		}
	}

	public static createState(entityType: string, d: IGenericEntity, userConfig: IUserConfigPackage, commands: IOutlookAppCommands, ctxCommands: IContextCommands): OutlookLocationContentsViewerState {

		let absUrl = d.ServerRelativeUrl || '';
		if(!absUrl.startsWith("https://")) {
			absUrl = d.ServerRelativeUrl ? new URL(d.ServerRelativeUrl, userConfig.tenantUrl).href : '';
		}
		
		return new OutlookLocationContentsViewerState(
			d.DisplayTitle,
			absUrl,
			d.NativeMetadataUrl,
			entityType,
			d.Id,
			userConfig,
			commands,
			ctxCommands
		);
	}

	public async load(): Promise<void> {
		this.loading = true;

		if (this.entityInfo) {

			this.setViewers(
				this.entities.map((d) => {
					if (this.entityInfo) {
						return EntityNavigatorState.createState(
							this.entityType.toString(), d, this.userConfig, this.commands, this.ctxCommands);
					} else {
						throw new Error('');
					}
				}) as OutlookLocationContentsViewerState[],
			);
		}

		this.setLoaded();
	}

	private setLoaded() {
		this.loading = false;
	}
}

export default observer(EntityNavigator);
